import { useEffect, useState } from "react";
import { api } from "../lib/api";
import { PageHeader } from "../components/Layout";
import {
  Table, TableBody, TableCell, TableHead, TableHeader, TableRow,
} from "../components/ui/table";
import {
  Select, SelectContent, SelectItem, SelectTrigger, SelectValue,
} from "../components/ui/select";

export default function AuditLogs() {
  const [rows, setRows] = useState([]);
  const [entity, setEntity] = useState("all");

  useEffect(() => {
    api.get("/audit-logs", { params: { entity: entity === "all" ? "" : entity } }).then((r) => setRows(r.data));
  }, [entity]);

  return (
    <>
      <PageHeader title="Audit Logs" subtitle="Sensitive changes & activity trail" />
      <div className="p-8 space-y-4">
        <Select value={entity} onValueChange={setEntity}>
          <SelectTrigger className="rounded-sm w-48" data-testid="audit-filter"><SelectValue /></SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All Entities</SelectItem>
            <SelectItem value="partner">Partner</SelectItem>
            <SelectItem value="ratecard">Ratecard</SelectItem>
            <SelectItem value="customer">Customer</SelectItem>
            <SelectItem value="transaction">Transaction</SelectItem>
            <SelectItem value="user">User</SelectItem>
          </SelectContent>
        </Select>
        <div className="border border-border rounded-sm bg-card overflow-hidden">
          <Table>
            <TableHeader>
              <TableRow className="bg-secondary/50">
                <TableHead>Action</TableHead><TableHead>Entity</TableHead>
                <TableHead>Detail</TableHead><TableHead>User</TableHead><TableHead>Time</TableHead>
              </TableRow>
            </TableHeader>
            <TableBody data-testid="audit-table">
              {rows.length === 0 && <TableRow><TableCell colSpan={5} className="text-center py-10 text-muted-foreground">No logs</TableCell></TableRow>}
              {rows.map((a, i) => (
                <TableRow key={i} className="hover:bg-secondary/30">
                  <TableCell><span className="label-caps text-[9px] px-2 py-1 bg-secondary rounded-sm">{a.action}</span></TableCell>
                  <TableCell className="capitalize">{a.entity}</TableCell>
                  <TableCell className="text-sm">{a.detail}</TableCell>
                  <TableCell className="text-sm">{a.user_name}</TableCell>
                  <TableCell className="text-xs text-muted-foreground">{new Date(a.created_at).toLocaleString("en-IN")}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </div>
      </div>
    </>
  );
}
